export const siteInfo = {
  brand: "热瓜前线",
  tagline: "前排蹲点，吃瓜不落人后",
  slogan: "全网热点围观站，帮你把热闹看明白",
  intro:
    "热瓜前线是一个专注热点话题观察与梳理的中文内容站。我们把正在被讨论的事整理成有条理的观察文章，让你在围观的同时，也能看清一件事情的来龙去脉。",
  email: "hello@reguaqianxian.com",
  since: "2026",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "话题分类", to: "/#topics" },
  { label: "今日热榜", to: "/#hot" },
  { label: "常见问题", to: "/#faq" },
  { label: "关于我们", to: "/about" },
];

export const contactChannels = [
  {
    icon: "ri-mail-line",
    label: "内容合作 / 线索投稿",
    value: "hello@reguaqianxian.com",
  },
  {
    icon: "ri-message-3-line",
    label: "内容反馈 / 纠错",
    value: "feedback@reguaqianxian.com",
  },
  {
    icon: "ri-time-line",
    label: "更新节奏",
    value: "工作日每日更新，重大话题加更",
  },
];

export const footerGroups = [
  {
    title: "热门话题",
    links: [
      { label: "网络热议", to: "/topic/network" },
      { label: "娱乐风向", to: "/topic/entertainment" },
      { label: "社会百态", to: "/topic/society" },
      { label: "科技新鲜事", to: "/topic/tech" },
    ],
  },
  {
    title: "更多栏目",
    links: [
      { label: "生活趣闻", to: "/topic/life" },
      { label: "体育快讯", to: "/topic/sports" },
      { label: "今日热榜", to: "/#hot" },
      { label: "常见问题", to: "/#faq" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "用户口碑", to: "/about#voices" },
      { label: "联系方式", to: "/about#contact" },
    ],
  },
];